import React, { useEffect, useState } from "react";
import { FiArrowUpRight, FiLoader } from "react-icons/fi";
import { apiFetch } from "../utils/apiFetch";
import OwnerBankDetails from "./OwnerBankDetails";
import { useAuth } from "../context/AuthContext";
import { ownerPlan } from "../utils/communityEntitlements.mjs";
import { Link } from "react-router";

export default function GroupPricingFields({ value, onChange, disabled, onBankReady, paidOnly = false, eligible }) {
  const { userInfo } = useAuth();
  const canOfferPremium = eligible ?? ownerPlan(userInfo?.subscriptionInfo) !== "default";
  const [options, setOptions] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    apiFetch(`${process.env.API_URL}/api/group-purchases/options`, { signal: controller.signal })
      .then(async response => { const data = await response.json(); if (!response.ok) throw Error(data.message); setOptions(data); })
      .catch(error => { if (!controller.signal.aborted) setError(error.message || "Could not load payment options"); });
    return () => controller.abort();
  }, []);
  return <fieldset disabled={disabled} className="space-y-4">
    <legend className={paidOnly ? "sr-only" : "mb-2 text-sm font-semibold"}>Premium membership</legend>
    {!paidOnly && <div className="flex gap-6">
      {(canOfferPremium ? ["free", "paid"] : ["free"]).map(access => <label key={access} className="flex items-center gap-2 text-sm font-medium">
        <input type="radio" name="group-access" value={access} checked={value.access === access} onChange={() => onChange({ ...value, access })} className="accent-orange-700" />{access === "paid" ? "Offer premium" : "Free only"}
      </label>)}
    </div>}
    {!canOfferPremium && <div className="space-y-3">
      <p className="text-sm text-gray-600">Offer premium memberships and host videos with a paid owner plan.</p>
      <Link to="/choose-plan" className="inline-flex min-h-11 items-center justify-center gap-2 rounded-md bg-orange-700 px-4 py-2 text-sm font-semibold text-white hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2">Upgrade to Plus or Pro<FiArrowUpRight aria-hidden="true" /></Link>
    </div>}
    {canOfferPremium && value.access === "paid" && <>
      {!options && !error && <FiLoader aria-label="Loading payment options" className="animate-spin" />}
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      <OwnerBankDetails missingOnly onReady={onBankReady} disabled={disabled} />
      <div className={paidOnly ? "" : "grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)] gap-3"}>
        {!paidOnly && <label className="space-y-2 text-sm font-medium"><span>Currency</span>
          <select aria-label="Currency" value={value.currency} onChange={event => onChange({ ...value, currency: event.target.value })} className="h-10 w-full rounded-md border border-gray-300 bg-white px-3">
            {(options?.currencies || [{ code: "INR" }]).map(item => <option key={item.code} value={item.code}>{item.code}</option>)}
          </select>
        </label>}
        <label className="block space-y-2 text-sm font-medium"><span>Monthly price (INR)</span>
          <input aria-label="Monthly price" type="number" inputMode="decimal" min="1" step="0.01" required value={value.amount} onChange={event => onChange({ ...value, amount: event.target.value })} className="h-10 w-full rounded-md border border-gray-300 bg-white px-3" />
        </label>
      </div>
    </>}
  </fieldset>;
}
